import {
  Box,
  Icon,
  IconsName,
  Text,
  ThemeColors,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import * as Styles from './providers-card.styles'

export const ProviderCard = ({
  color,
  title,
  value,
  icon,
}: {
  color: ThemeColors
  title: string
  value: string | number
  icon?: IconsName
}) => {
  const theme = useTheme()
  return (
    <Box
      direction="column"
      borderRadius={theme.border_radius.card}
      boxShadow={theme.box_shadow.card}
      padding={3}
      gap={2}
      border={
        color === 'warning'
          ? { width: 2, color: color }
          : {
              width: 1,
              color: 'grey_5',
            }
      }
    >
      <Box alignItems="center" gap={1}>
        {icon ? (
          <Icon name={icon} color={color} size={20} />
        ) : color === 'warning' ? (
          <Icon name="flag" color={color} size={20} />
        ) : (
          <Box
            borderRadius="50%"
            backgroundColor={color}
            height="12px"
            width="12px"
          />
        )}
        <Text
          size="small"
          fontWeight={500}
          color={color === 'warning' ? color : 'grey_2'}
        >
          {title}
        </Text>
      </Box>
      <Box alignItems="center" gap={1}>
        <Text variant="h4">{value} </Text>
        <Styles.CustomValue>
          {color === 'warning' && 'Fornecedores'}
        </Styles.CustomValue>
      </Box>
    </Box>
  )
}
